import { useAuth0 } from '@auth0/auth0-react';

const NAMESPACE = 'https://api.murkocapital.com';

export function useAuth() {
  const {
    user,
    isAuthenticated,
    isLoading,
    loginWithRedirect,
    logout,
  } = useAuth0();

  const role    = user?.[`${NAMESPACE}/role`]    ?? null;
  const clubs   = user?.[`${NAMESPACE}/clubs`]   ?? [];
  // modules: array from app_metadata e.g. ["t2m","pb101","lead_engine"]
  // null means no restriction — all modules visible (admin/mloc default)
  const modules = user?.[`${NAMESPACE}/modules`] ?? null;

  const isAdmin = role === 'admin';
  const isMloc  = role === 'mloc';
  const isMgr   = role === 'mgr';
  const isFd    = role === 'fd';

  const hasAllClubs = clubs.includes('ALL');

  function canAccessClub(locationId) {
    if (hasAllClubs) return true;
    return clubs.includes(locationId);
  }

  // Returns true if the user can see this module.
  // modules === null → unrestricted (admin/mloc or any user without modules set)
  // modules === []   → no modules (shouldn't happen but safe)
  // modules = ["t2m","pb101"] → only those two
  function hasModule(moduleKey) {
    if (modules === null) return true;
    return modules.includes(moduleKey);
  }

  return {
    user,
    isAuthenticated,
    isLoading,
    loginWithRedirect,
    logout,
    role,
    clubs,
    modules,
    isAdmin,
    isMloc,
    isMgr,
    isFd,
    hasAllClubs,
    canAccessClub,
    hasModule,
  };
}